import { NumberInput, SimpleGrid } from '@mantine/core';
import { useTranslate } from '@tolgee/react';
import { Controller, type Control } from 'react-hook-form';
import type { SusFormValues } from './susFormSchema';

type Props = {
  control: Control<SusFormValues>;
  disabled: boolean;
};

const thresholdFields = [
  'seuil_bas_quotidien',
  'seuil_haut_quotidien',
  'seuil_bas_duree_passage',
  'seuil_haut_duree_passage',
] as const;

/** Saisie des seuils bas/haut, par paires (volume quotidien, durée de passage). */
const SusThresholdFields = ({ control, disabled }: Props) => {
  const { t } = useTranslate();

  return (
    <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="xs">
      {thresholdFields.map(name => (
        <Controller
          key={name}
          control={control}
          name={name}
          render={({ field, fieldState }) => (
            <NumberInput
              ref={field.ref}
              name={field.name}
              onBlur={field.onBlur}
              value={field.value ?? ''}
              onChange={value => field.onChange(value === '' ? null : Number(value))}
              label={t(`admin.sus.detail.${name}`)}
              min={0}
              allowDecimal={false}
              allowNegative={false}
              error={
                fieldState.error
                  ? t(
                      field.value == null
                        ? 'admin.sus.form.error.required'
                        : 'admin.sus.form.error.seuil_ordre',
                    )
                  : undefined
              }
              disabled={disabled}
              required
            />
          )}
        />
      ))}
    </SimpleGrid>
  );
};

export default SusThresholdFields;
